// extracted by mini-css-extract-plugin
module.exports = {"section":"BottomAction_section__Bu3j5","show":"BottomAction_show__ufyuq"};